exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._6UC-Bun78ObCcSwOy6I9yQ\\=\\={position:relative}html[dir] ._6UC-Bun78ObCcSwOy6I9yQ\\=\\={background:transparent}", ""]);
// Exports
exports.locals = {
	"container": "_6UC-Bun78ObCcSwOy6I9yQ=="
};